import {
  FulfillmentOrderForDocumentResponseDto,
  GetDocumentSettingsResponseDto,
  OrderForDocumentResponseDto,
  OcaLabelResponseDto,
  StoreForDocumentResponseDto,
} from '@tiendanube/common';
import GeneralDocumentPreviewFields from './GeneralDocumentPreviewFields/GeneralDocumentPreviewFields';
import OcaLabelError from '../../../OcaLabelError';

interface DocumentOcaPreviewProps {
  information: Array<{
    order: OrderForDocumentResponseDto;
    fulfillmentOrder: FulfillmentOrderForDocumentResponseDto;
    store: StoreForDocumentResponseDto;
    ocaLabel: OcaLabelResponseDto;
  }>;
  settings: GetDocumentSettingsResponseDto;
  locationId?: string;
}

function DocumentOcaPreview({
  information,
  settings,
  locationId,
}: Readonly<DocumentOcaPreviewProps>) {
  return (
    <>
      {information
        .filter(
          ({ fulfillmentOrder }) =>
            !locationId || fulfillmentOrder.assignedLocation.id === locationId,
        )
        .map(({ order, fulfillmentOrder, store, ocaLabel }) => {
          const updatedFulfillmentOrder = {
            ...fulfillmentOrder,
            tracking: ocaLabel.trackingCode
              ? {
                  ...fulfillmentOrder.tracking,
                  code: ocaLabel.trackingCode,
                }
              : fulfillmentOrder.tracking,
          };

          return (
            <div
              key={fulfillmentOrder.number + order.number}
              className="stratus--order-document oca"
            >
              <div className="oca-document">
                <GeneralDocumentPreviewFields
                  fulfillmentOrder={updatedFulfillmentOrder}
                  order={order}
                  settings={settings}
                  store={store}
                  isOca
                />
              </div>
              {!ocaLabel.error && !!ocaLabel.html && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: ocaLabel.html,
                  }}
                />
              )}
              {(!!ocaLabel.error || (!ocaLabel.error && !ocaLabel.html)) && (
                <div className="error">
                  <OcaLabelError error={ocaLabel.error} />
                </div>
              )}
            </div>
          );
        })}
    </>
  );
}

export default DocumentOcaPreview;
